export default __webpack_public_path__ + "static/media/perksbanner.caa44ffd.jpeg";